module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/kristinberlehner/sites/recipe-search/wp-content/themes/nutrition-for-me/node_modules/core-js/modules/_library.js
// module id = 58
// module chunks = 0